import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'

import { setWebSDKDataReceive } from '../ActionCreators'

export const VNWebSDKDataBridge = (props) => {
  // HOOKS
  const dispatch = useDispatch()
  const [broadcasterAvailable, setBroadcasterAvailable] = useState(false)

  // initialize the WEBSDK Bridge on mount
  useEffect(() => {
    window.VENUENEXT_WEBSDK = {
      DATA_BRIDGE: dataBridgeReceive,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (broadcasterAvailable) return
    if (window.localStorage?.getItem('cfd_web_test_mode') !== 'true') return

    const timeout = setTimeout(() => {
      if (window.Broadcaster?.name === 'cfd_web_test_mode') {
        setBroadcasterAvailable(true)
        clearTimeout(timeout)
      }
    }, 1000)
    return () => clearTimeout(timeout)
  }, [broadcasterAvailable])

  const isTestMode = useMemo(() => {
    return window.localStorage?.getItem('cfd_web_test_mode') === 'true' && broadcasterAvailable
  }, [broadcasterAvailable])

  useEffect(() => {
    if (isTestMode) {
      window.Broadcaster.onmessage = (event) => {
        if (event.data.data) {
          dataBridgeReceive(event.data.data)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTestMode])

  // LOCAL FUNCS

  // called when WebSDK wants to make calls into react, this is open to the public
  // base64Parameters : String - This is the parameters being passed from native that is base64 encoded
  const dataBridgeReceive = (base64Parameters) => {
    // decode and parse the payload back to a JSON obj
    var decodedParams = window.atob(base64Parameters)
    var payload = JSON.parse(decodedParams)
    dispatch(setWebSDKDataReceive(payload))
  }

  return <>{props.children}</>
}
